
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("iIrS6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ResizeButtonTooltip", () => $c8459c491f6065bc$export$680dc7b2ca125eea);
$parcel$export(module.exports, "TooltipNode", () => $c8459c491f6065bc$export$650cc9b24ce3a5c9);
$parcel$export(module.exports, "default", () => $c8459c491f6065bc$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $aWse0 = parcelRequire("aWse0");

var $kQ48I = parcelRequire("kQ48I");
const $c8459c491f6065bc$export$680dc7b2ca125eea = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, children: children })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const text = isLeftSidebarCollapsed ? intl.formatMessage((0, $kQ48I.messages).expand) : intl.formatMessage((0, $kQ48I.messages).collapse);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8459c491f6065bc$export$650cc9b24ce3a5c9, {
            text: text,
            char: "["
        }),
        hideTooltipOnClick: true,
        position: "right",
        testId: "page-container-v2.common.ui.sidebar.resize-button-tooltip.tooltip"
    }, children);
};
var $c8459c491f6065bc$export$2e2bcd8739ae039 = $c8459c491f6065bc$export$680dc7b2ca125eea;
const $c8459c491f6065bc$export$650cc9b24ce3a5c9 = ({ text: text, char: char })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8459c491f6065bc$var$TooltipWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8459c491f6065bc$var$ShortcutWrapper, null, char));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8459c491f6065bc$var$TooltipWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1q9y _1e0c1txw _n3tdv77o _ca0qv77o",
            __cmplp.className
        ])
    });
});
const $c8459c491f6065bc$var$ShortcutWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _bfhk1bsc _18u01b66 _ca0qt94y _u5f3u2gc _n3tdt94y _19bvu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kQ48I", function(module, exports) {

$parcel$export(module.exports, "messages", () => $88b974d8e8bff89f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $88b974d8e8bff89f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    expand: {
        "id": "page-container-v2.common.sidebar.resize-button-tooltip.expand",
        "defaultMessage": "Expand"
    },
    collapse: {
        "id": "page-container-v2.common.sidebar.resize-button-tooltip.collapse",
        "defaultMessage": "Collapse"
    }
});

});



//# sourceMappingURL=async-sidebar-resize-button.21637848.js.map
